import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { useState } from 'react'
import CustomerNameLookup from './CustomerNameLookup'
import classes from './CustomerNameLookup.module.scss'
import './CustomerNameLookup.scss'

const CustomerNameLookupDialog = props => {
  const {
    displayCustomerNameLookup,
    onHideCustomerNameLookup,
    setPartySiteNumber,
    useCloseButtonOnly,
    autoHideOnSelect,
  } = props

  const [currentRowSelected, setCurrentRowSelected] = useState('')

  const onHide = () => {
    onHideCustomerNameLookup(false)
    // setCurrentRowSelected("");
  }

  const onClickSelectParty = () => {
    setPartySiteNumber(currentRowSelected.partySiteNumber)
    autoHideOnSelect !== false && onHide()
  }

  const customerLookupDialogFooter = (
    <div className={`${classes['footer-btns']}`}>
      <Button
        label={!useCloseButtonOnly ? 'CANCEL' : 'CLOSE'}
        className={classes['default-cancel-button']}
        onClick={onHide}
      />
      <Button
        label="SELECT PARTY"
        className={classes['default-save-button']}
        onClick={() => onClickSelectParty()}
        disabled={!currentRowSelected}
      />
    </div>
  )

  return (
    <>
      <Dialog
        header="Customer Name Lookup"
        onHide={onHide}
        style={{ width: '80vw', height: '80vh' }}
        visible={displayCustomerNameLookup}
        footer={customerLookupDialogFooter}
      >
        <CustomerNameLookup
          tableHeight="100%"
          containerHeight="calc(100% - 190px)"
          onCurrentRowSelected={setCurrentRowSelected}
        />
      </Dialog>
    </>
  )
}

export default CustomerNameLookupDialog
